__turbopack_context__.v({
  "appBadge": "Footer-module__hP-FLq__appBadge",
  "appBadgeDark": "Footer-module__hP-FLq__appBadgeDark",
  "appBadgeLight": "Footer-module__hP-FLq__appBadgeLight",
  "appBadgePadded": "Footer-module__hP-FLq__appBadgePadded",
  "appBadges": "Footer-module__hP-FLq__appBadges",
  "appGroup": "Footer-module__hP-FLq__appGroup",
  "appGroupCompact": "Footer-module__hP-FLq__appGroupCompact",
  "bottomRow": "Footer-module__hP-FLq__bottomRow",
  "brandBody": "Footer-module__hP-FLq__brandBody",
  "brandCard": "Footer-module__hP-FLq__brandCard",
  "brandRow": "Footer-module__hP-FLq__brandRow",
  "brandText": "Footer-module__hP-FLq__brandText",
  "brandTitle": "Footer-module__hP-FLq__brandTitle",
  "browseAll": "Footer-module__hP-FLq__browseAll",
  "browseLink": "Footer-module__hP-FLq__browseLink",
  "browseLinks": "Footer-module__hP-FLq__browseLinks",
  "browseRow": "Footer-module__hP-FLq__browseRow",
  "browseTail": "Footer-module__hP-FLq__browseTail",
  "colTitle": "Footer-module__hP-FLq__colTitle",
  "creaNotice": "Footer-module__hP-FLq__creaNotice",
  "creaRow": "Footer-module__hP-FLq__creaRow",
  "divider": "Footer-module__hP-FLq__divider",
  "fineprint": "Footer-module__hP-FLq__fineprint",
  "footer": "Footer-module__hP-FLq__footer",
  "inner": "Footer-module__hP-FLq__inner",
  "legalButton": "Footer-module__hP-FLq__legalButton",
  "legalCell": "Footer-module__hP-FLq__legalCell",
  "legalGrid": "Footer-module__hP-FLq__legalGrid",
  "legalLink": "Footer-module__hP-FLq__legalLink",
  "legalLinks": "Footer-module__hP-FLq__legalLinks",
  "link": "Footer-module__hP-FLq__link",
  "linkCol": "Footer-module__hP-FLq__linkCol",
  "linkCols": "Footer-module__hP-FLq__linkCols",
  "reciprocityLink": "Footer-module__hP-FLq__reciprocityLink",
});
